import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

import { UserProvider } from "./components/0. Header/UserContext";
import Layout from "./Layout"; //Header

//Pages
import HomePage from "./pages/0. HomePage/HomePage";
import FeedPage from "./pages/0. HomePage/FeedPage";
import NotFoundPage from "./pages/0. HomePage/NotFoundPage";

import MaestrasPage from "./pages/1. Gestión de Comunidades/MaestrasPage";
import CursosPage from "./pages/1. Gestión de Comunidades/CursosPage";
import ActividadesPage from "./pages/1. Gestión de Comunidades/ActividadesPage";
import ComentariosPage from "./pages/1. Gestión de Comunidades/ComentariosPage";
import SolicitudesPage from "./pages/1. Gestión de Comunidades/SolicitudesPage";
import CumpleañosPage from "./pages/1. Gestión de Comunidades/CumpleañosPage";
import WhatsappPage from "./pages/1. Gestión de Comunidades/WhatsappPage";

import PostulantesPage from "./pages/2. Módulo de Selección/PostulantesPage";
import ProcesosPage from "./pages/2. Módulo de Selección/ProcesosPage";
import ProcesosEsperaPage from "./pages/2. Módulo de Selección/EsperaPage";
import ProcesoMaestrasPage from "./pages/2. Módulo de Selección/ProcesoMaestrasPage";
import ResumenPage from "./pages/2. Módulo de Selección/ResumenPage";

import AsistenciaPage from "./pages/3. Módulo de Asistencia/AsistenciaPage";

const App = () => {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Intranet Home */}
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="feed"
            element={
              <Layout>
                <FeedPage />
              </Layout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Gestión de Comunidades */}
          {/* Maestras */}
          <Route
            path="maestras"
            element={
              <Layout>
                <MaestrasPage />
              </Layout>
            }
          />
          <Route
            path="maestras/:rut"
            element={
              <Layout>
                <MaestrasPage />
              </Layout>
            }
          />
          <Route
            path="maestras_externas"
            element={
              <Layout>
                <MaestrasPage />
              </Layout>
            }
          />
          <Route
            path="alumna"
            element={
              <Layout>
                <MaestrasPage />
              </Layout>
            }
          />
          <Route
            path="especial"
            element={
              <Layout>
                <MaestrasPage />
              </Layout>
            }
          />
          <Route path="api/perfiles/anadir_maestras/" />
          <Route path="api/perfiles/editar_maestras/:rut/" />
          {/* Cursos */}
          <Route
            path="cursos"
            element={
              <Layout>
                <CursosPage />
              </Layout>
            }
          />
          <Route
            path="cursos/:id"
            element={
              <Layout>
                <CursosPage />
              </Layout>
            }
          />
          <Route path="api/perfiles/anadir_cursos/" />
          <Route path="api/perfiles/editar_cursos/:id/" />
          {/* Actividades */}
          <Route
            path="actividades"
            element={
              <Layout>
                <ActividadesPage />
              </Layout>
            }
          />
          <Route
            path="actividades/:id"
            element={
              <Layout>
                <ActividadesPage />
              </Layout>
            }
          />
          <Route path="api/perfiles/anadir_actividades/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/editar_actividades/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/actividad_anadir_maestra/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/actividad_anadir_maestra/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Comentarios */}
          <Route
            path="comentarios"
            element={
              <Layout>
                <ComentariosPage />
              </Layout>
            }
          />
          {/* Solicitudes */}
          <Route
            path="solicitudes"
            element={
              <Layout>
                <SolicitudesPage />
              </Layout>
            }
          />
          <Route path="api/formularios/ver_maestra/:rut/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Cumpleaños */}
          <Route
            path="cumpleaños"
            element={
              <Layout>
                <CumpleañosPage />
              </Layout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Módulo de Selección */}
          {/* Postulaciones */}
          <Route path="api/seleccion/agregar_postulante_proceso/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Entrevista */}
          <Route
            path="postulantes"
            element={
              <Layout>
                <PostulantesPage />
              </Layout>
            }
          />
          <Route path="api/seleccion/editar_postulante_entrevista/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Psicoanalisis */}
          <Route
            path="procesos"
            element={
              <Layout>
                <ProcesosPage />
              </Layout>
            }
          />
          <Route
            path="espera"
            element={
              <Layout>
                <ProcesosEsperaPage />
              </Layout>
            }
          />
          <Route
            path="proceso_maestras"
            element={
              <Layout>
                <ProcesoMaestrasPage />
              </Layout>
            }
          />
          <Route path="api/seleccion/editar_postulante_psicoanalisis/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Historial */}
          <Route
            path="resumen"
            element={
              <Layout>
                <ResumenPage />
              </Layout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Módulo de Asistencia */}
          {/* Asistencia */}
          <Route
            path="asistencia"
            element={
              <Layout>
                <AsistenciaPage />
              </Layout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Otros */}
          {/* Whatsapp */}
          <Route
            path="whatsapp"
            element={
              <Layout>
                <WhatsappPage />
              </Layout>
            }
          />
          {/* Admin */}
          <Route path="admin/" />
          <Route path="api/perfiles/maestras/?excel=true" />
          <Route path="api/generar_qr/" />
          {/* Public */}
          <Route path="api/formularios/agregar_comunidades/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_comunidades/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_empresas/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_empresas/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Catch-all route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;
